module.exports = __webpack_public_path__ + "static/media/AnthonySherfield.918c49bb.jpg";